import { Directive, Input, ElementRef, inject } from '@angular/core';

// This directive controls display of checkbox button in the Clarity datagrid column header

@Directive({
  selector: '[appClrCheckboxDisplay]',
})
export class ClrCheckboxDisplayDirective {
  private elementRef = inject(ElementRef);

  @Input('appClrCheckboxDisplay') set display(show: boolean) {
    const classList = this.elementRef.nativeElement.classList;
    if (!show) classList.add('clr_disabled');
    else classList.remove('clr_disabled');
  }
}
